import { render } from "./DigitalTransformationGuide.vue?vue&type=template&id=4478abf8&scoped=true"
import script from "./DigitalTransformationGuide.vue?vue&type=script&lang=js"
export * from "./DigitalTransformationGuide.vue?vue&type=script&lang=js"

import "./DigitalTransformationGuide.vue?vue&type=style&index=0&id=4478abf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4478abf8"]])

export default __exports__